document.addEventListener('alpine:init', () => {
  Alpine.data('ProductFormQuantity', () => ({
    qty: 1,
    $qtyWrap: null,
    $qty: null,
    $section: null,
    init() {
      let am = this;

      document.addEventListener('init-ProductFormQuantity', (e) => {
        if (am.$qtyWrap) return;
        console.log('quantity update')
        am.$qtyWrap = e.target;
        let $qty = am.$qtyWrap.querySelector('[name=quantity]');
        am.$qty = $qty;
        am.InitVariantPriceUpdate();
      });
    },

    FormQtyChange(e) {
      let am = this;
      if (e.target.classList.contains('js-qty-down')) {
        let newQty = am.qty - 1;
        console.log('quantity update down')
        am.qty -= (newQty >= 1) ? 1 : 0;
      }
      else if (e.target.classList.contains('js-qty-up')) {
        am.qty += 1;
        console.log('quantity update up')
      }
      else {
        let $qty = am.$qtyWrap.querySelector('[name="quantity"]');
        let qty = parseInt($qty.value);
        console.log('quantity update else')
        am.qty = qty;  
      }

      setTimeout(() => {
        am.$qtyWrap.dispatchEvent(new CustomEvent('update-variant-price'));
      }, 0);
  },

    InitVariantPriceUpdate() {
      let am = this;

      am.$qtyWrap.addEventListener('update-variant-price', (e) => {
        console.log(e);
        let qty = parseInt(am.$qtyWrap.querySelector('[name=quantity]').value);
        let variant_price;
        const subscription_input = document.querySelector('.purchase-options-wrapper .subscription-plan-wrapper:not(.hidden) input[name="selling_plan_group"]:checked')
        if (subscription_input && subscription_input.value !== 'one_time') {
          // console.log('subscription_input :',subscription_input)
          // console.log('subscription_input value:',subscription_input.value)


          const input_parent = subscription_input.closest('.subscription-plan-wrapper')
          // console.log('input_parent', input_parent)
          let price = input_parent.querySelector('.purchase-option-details:not(.hidden) .purchase-option-price-amount').textContent;
          // just the numbers, please
          price = price.replace(/\D/g, '');
          // console.log('subscription price', price)
          variant_price = parseFloat(price)
        } else {
          variant_price = parseFloat(am.$qtyWrap.dataset.variantPrice);
        }
        let product_id = am.$qtyWrap.dataset.productId;
        let total_price = qty * variant_price;
        
        
        document.querySelectorAll(`.product_form[data-product-id="${ product_id }"]`).forEach(($form) => {
           // update main form qty
          $form.querySelectorAll('[name="quantity"]').forEach(($qty) => {
            $qty.value = qty;
            $qty.dispatchEvent(new Event('change'));
          });
          // update prices
          $form.querySelectorAll('[data-regular-price]').forEach(($price) => {
            $price.textContent = WAU.Helpers.formatMoney(total_price, '${{amount}}');
          });
        });


       
      });
    }
  }));
});



const UTILS_ADAPTED = {
  async GetCart() {
    return await fetch('/cart.js').then(res => res.json());
  },
  async GetAddressFromLatLng(api_key, lat_lng) {
    if (!api_key) {
      console.error('API KEY MISSING'); 
      return;
    }
    let res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat_lng}&result_type=postal_code&key=${api_key}`).then(res => res.json());
    
    if (!res.results.length) {
      return false;
    }
    
    // Extract just the postal code from the response
    let postal_code = null;
    for (let result of res.results) {
      for (let component of result.address_components) {
        if (component.types.includes('postal_code')) {
          postal_code = component.long_name;
          break;
        }
      }
      if (postal_code) break;
    }
    
    return { postal_code };
  },
  async GetAddressFromPostalCode(api_key, postal_code) {
  if (!api_key) {
    console.error('API KEY MISSING'); 
    return;
  }
  
  // Try method 1: result_type
  const url1 = `https://maps.googleapis.com/maps/api/geocode/json?address=${postal_code}&result_type=postal_code&key=${api_key}`;
  console.log('=== Method 1: result_type ===');
  console.log('URL:', url1);
  
  let res1 = await fetch(url1).then(res => res.json());
  console.log('Method 1 response:', JSON.stringify(res1, null, 2));
  
  // Try method 2: components
  const url2 = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${postal_code}|country:US&key=${api_key}`;
  console.log('=== Method 2: components ===');
  console.log('URL:', url2);
  
  let res2 = await fetch(url2).then(res => res.json());
  console.log('Method 2 response:', JSON.stringify(res2, null, 2));
  
  // Use whichever method returns results
  let res = res1.results && res1.results.length ? res1 : res2;
  console.log('Final choice - using:', res1.results && res1.results.length ? 'Method 1' : 'Method 2');
  
  if (!res.results || !res.results.length) {
    console.log('No results found with either method - returning false');
    return false;
  }
  
  console.log('Success - returning postal_code');
  return { postal_code };
}
};

document.addEventListener('alpine:init', () => {
  // Store for sharing state between components
  Alpine.store('locationSelector', {
    customer_zip_code: '',
    loaded: false,
    invalid_postal_code: false
  });

  // ============================================
  // FIXED: LocationTrigger component
  // ============================================
  Alpine.data('LocationTrigger', () => ({
    customer_zip_code: '',
    loaded: false,
    
    init() {
      const store = Alpine.store('locationSelector');
      
      // Initialize from store immediately
      this.customer_zip_code = store.customer_zip_code || '';
      this.loaded = store.loaded || false;
      
      // Fallback - check cart directly if store isn't loaded yet
      if (!this.loaded) {
        this.checkCartForLocation();
      }
      
      // Watch for future changes
      this.$watch(() => Alpine.store('locationSelector').customer_zip_code, (value) => {
        this.customer_zip_code = value || '';
      });
      this.$watch(() => Alpine.store('locationSelector').loaded, (value) => {
        this.loaded = value;
      });
    },
    
    async checkCartForLocation() {
      try {
        const cart = await fetch('/cart.js').then(res => res.json());
        if (cart.attributes && cart.attributes.customer_zip_code) {
          this.customer_zip_code = cart.attributes.customer_zip_code;
          this.loaded = true;
          Alpine.store('locationSelector').customer_zip_code = cart.attributes.customer_zip_code;
          Alpine.store('locationSelector').loaded = true;
        } else {
          this.loaded = true;
          Alpine.store('locationSelector').loaded = true;
        }
      } catch (e) {
        console.error('Error checking cart for location:', e);
        this.loaded = true;
        Alpine.store('locationSelector').loaded = true;
      }
    },
    
    openModal() {
      const modal = document.getElementById('Modal-Location');
      if (modal) {
        modal.classList.add('modal--active');
        document.body.style.overflow = 'hidden';
      }
    }
  }));

  // ============================================
  // IMPROVED: LocationSelector component (the modal)
  // ============================================
  Alpine.data('LocationSelector', () => ({
    customer_zip_code: '',
    api_key: 'AIzaSyCE0SS6YLhzDJgIwSDRRukhYu6Nlmx1H10',
    flags: {
      loaded: false,
      invalid_postal_code: false
    },
    
    mounted() {
      let am = this;
      am.CheckCustomerAddress();
      am.InitLocation();

      // Update store when local data changes
      am.$watch('customer_zip_code', (value) => {
        Alpine.store('locationSelector').customer_zip_code = value;
      });
      am.$watch('flags.loaded', (value) => {
        Alpine.store('locationSelector').loaded = value;
      });
      am.$watch('flags.invalid_postal_code', (value) => {
        Alpine.store('locationSelector').invalid_postal_code = value;
      });
    },
    
    CheckCustomerAddress() {
      let am = this;
      const customerZipContainer = document.getElementById('customer-zip-container');
      const customerZip = customerZipContainer ? customerZipContainer.getAttribute('data-customer-zip') : '';
      
      if (customerZip && customerZip !== '') {
        console.log('Found customer address zip:', customerZip);
        am.customer_zip_code = customerZip;
        am.flags.loaded = true;
        // FIX: Also update the store immediately
        Alpine.store('locationSelector').customer_zip_code = customerZip;
        Alpine.store('locationSelector').loaded = true;
        return true;
      }
      return false;
    },
    
    InitLocation() {
      let am = this;
      const SESSION_KEY_MODAL_PROMPTED = 'location_modal_prompted_avo';
      const SESSION_KEY_LOCATION_SET = 'location_already_set_avo';
      const SESSION_KEY_GEOLOCATION_IN_PROGRESS = 'geolocation_in_progress_avo';
      
      // If customer has address, skip geolocation
      if (am.CheckCustomerAddress()) {
        sessionStorage.setItem(SESSION_KEY_LOCATION_SET, 'true');
        return;
      }

      (async() => {
        let cart = await UTILS_ADAPTED.GetCart();
        am.SetLocation_Instance(cart);
        
        let has_zipLocation = cart.attributes.hasOwnProperty('customer_zip_code') && 
                             cart.attributes.customer_zip_code !== '' &&
                             cart.attributes.customer_zip_code !== null;
        
        // CRITICAL: If cart already has location, mark as set and stop (but still load it!)
        if (has_zipLocation) {
          console.log('Cart already has zip code:', cart.attributes.customer_zip_code);
          sessionStorage.setItem(SESSION_KEY_LOCATION_SET, 'true');
          am.flags.loaded = true;
          // FIX: Ensure store is updated
          Alpine.store('locationSelector').customer_zip_code = cart.attributes.customer_zip_code;
          Alpine.store('locationSelector').loaded = true;
          return;
        }
        
        // CRITICAL: Check if location was already set in this session (prevents NEW geolocation attempts)
        if (sessionStorage.getItem(SESSION_KEY_LOCATION_SET) === 'true') {
          console.log('Location already set this session, skipping geolocation');
          am.flags.loaded = true;
          // FIX: Ensure store is updated
          Alpine.store('locationSelector').loaded = true;
          return;
        }
        
        // CRITICAL: Check if geolocation is already in progress
        if (sessionStorage.getItem(SESSION_KEY_GEOLOCATION_IN_PROGRESS) === 'true') {
          console.log('Geolocation already in progress, aborting');
          am.flags.loaded = true;
          // FIX: Ensure store is updated
          Alpine.store('locationSelector').loaded = true;
          return;
        }
        
        // FIX: Always ensure loaded is set to true after initialization
        // This ensures the button is visible even if geolocation fails or is denied
        am.flags.loaded = true;
        Alpine.store('locationSelector').loaded = true;
        
        // Only proceed with geolocation if we don't have a location yet
        if (navigator.geolocation) {
          // Mark geolocation as in progress
          sessionStorage.setItem(SESSION_KEY_GEOLOCATION_IN_PROGRESS, 'true');
          
          let geolocationFired = false; // Prevent multiple callbacks
          
          let successCallback = async (current_position) => {
            // Prevent multiple fires
            if (geolocationFired) {
              console.log('Geolocation already processed, ignoring duplicate callback');
              return;
            }
            geolocationFired = true;
            
            let lat_lng = `${current_position.coords.latitude},${current_position.coords.longitude}`;
            let res_geolocate = await UTILS_ADAPTED.GetAddressFromLatLng(am.api_key, lat_lng);

            if (res_geolocate && res_geolocate.postal_code) {
              console.log('Setting location from geolocation:', res_geolocate.postal_code);
              // Mark as set BEFORE the cart update to prevent race condition
              sessionStorage.setItem(SESSION_KEY_LOCATION_SET, 'true');
              sessionStorage.removeItem(SESSION_KEY_GEOLOCATION_IN_PROGRESS);
              am.SetCartLocation(res_geolocate.postal_code);
            } else {
              sessionStorage.removeItem(SESSION_KEY_GEOLOCATION_IN_PROGRESS);
            }
          }

          let errorCallback = async () => {
            sessionStorage.removeItem(SESSION_KEY_GEOLOCATION_IN_PROGRESS);
            // Don't auto-open modal - user can click icon manually
            console.log('Geolocation denied or failed - user can manually enter zip via icon');
          }
          
          navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
            timeout: 10000, // Add timeout
            maximumAge: 300000 // Cache for 5 minutes
          });
        }
        else {
          console.log('Geolocation not available - user can manually enter zip via icon');
        }
      })();
    },
    
    SetLocation_Instance(cart) {
      let am = this;
      am.customer_zip_code = cart.attributes.hasOwnProperty('customer_zip_code') ? cart.attributes.customer_zip_code : '';
      // FIX: Also update store
      if (am.customer_zip_code) {
        Alpine.store('locationSelector').customer_zip_code = am.customer_zip_code;
      }
    },
    
    SetCartLocation(zip_code) {
  let am = this;
  if (!zip_code) return;
  
  console.log('=== SetCartLocation ===');
  console.log('zip_code:', zip_code);
  console.log('window.zipArray exists:', !!window.zipArray);
  console.log('window.zipArray:', window.zipArray);
  console.log('zip_code type:', typeof zip_code);
  
  const isLocal = window.zipArray && window.zipArray.includes(zip_code);
  console.log('isLocal result:', isLocal);
  console.log('Does zipArray include this zip?', window.zipArray ? window.zipArray.includes(zip_code) : 'no zipArray');
  
  let attArray = [];
  attArray.push({key: 'customer_zip_code', value: zip_code});
  attArray.push({key: 'customer_is_local', value: isLocal ? 'true' : 'false'});
  attArray.push({key: 'customer_order_type', value: isLocal ? 'Local Delivery' : ''});
  
  console.log('Setting cart attributes:', attArray);
  
  am.customer_zip_code = zip_code;
  Alpine.store('locationSelector').customer_zip_code = zip_code;
  Alpine.store('locationSelector').loaded = true;
  
  window.MonScripts.updateCartAttributeArray(attArray);
},
    
    async e_UpdatePostalCode(e) {
      let am = this;
      let $modal = e.target.closest('.modal__container');
      if (!$modal) {
        // FIX: Fallback to finding the modal by ID
        $modal = document.getElementById('Modal-Location');
      }
      if (!$modal) return;
      
      let $postal_code = $modal.querySelector('input[name="postal_code"], input#postal_code');
      if (!$postal_code) return;

      let postal_code = $postal_code.value.trim();

      const zipRegex = /^\d{5}(-\d{4})?$/;
      if (!zipRegex.test(postal_code)) {
        am.flags.invalid_postal_code = true;
        return;
      }

      if (am.api_key) {
        let res_geolocate = await UTILS_ADAPTED.GetAddressFromPostalCode(am.api_key, postal_code);
        if (!res_geolocate) {
          am.flags.invalid_postal_code = true;
          return;
        }
      }

      am.flags.invalid_postal_code = false;
      
      // Mark location as set before updating cart
      sessionStorage.setItem('location_already_set_avo', 'true');
      am.SetCartLocation(postal_code);

      document.getElementById('Modal-Location').classList.remove('modal--active');
      document.body.style.overflow = '';
    },
    
    OpenLocationModal() {
      const modal = document.getElementById('Modal-Location');
      if (modal) {
        modal.classList.add('modal--active');
        document.body.style.overflow = 'hidden';
      }
    }
  })); 
});

// Add this as a global function (keep existing)
window.OpenLocationModal = function() {
  const modal = document.getElementById('Modal-Location');
  if (modal) {
    modal.classList.add('modal--active');
    document.body.style.overflow = 'hidden';
  }
}


// update price on selling plan change
document.addEventListener('change', (e) => {
  // console.log('e.target:::', e.target)
  const check_is_selling_plan = e.target.closest('input[name="selling_plan_group"]')
  const check_is_selling_plan_type = e.target.closest('.sss-selling-plan-select')

  if (!check_is_selling_plan && !check_is_selling_plan_type) return;

  // console.log('updating price')
  const qty_input = document.querySelector('.product__quantity--selector input[name="quantity"]')
  
  if (check_is_selling_plan && qty_input) {
    // pretend the quantity changed to trigger the code to update the price
    qty_input.dispatchEvent(new Event('change'));
  } else if (check_is_selling_plan_type && qty_input) {
    setTimeout(() => {
      qty_input.dispatchEvent(new Event('change'));
    }, 10)
  }
  
  

})